export enum CompatibleAccessMode {
    Direct = 'direct',
    Materialized = 'materialized',
}
